export default "__VITE_ASSET__CUy4E66i__"